module.exports = __webpack_public_path__ + "static/media/flight-radar.ae30514b.png";